<template>
    <div class="col-12 col-md-6 col-lg-4 mb-4">
        <md-card md-with-hover :class="management ? 'no-cursor' : ''">
            <slot></slot>
        </md-card>
    </div>
</template>

<script>
export default {
    name: "Card",
    props: ["management"]
};
</script>

<style lang="scss">
.card-container {
    padding: 15px;
}
.md-card {
    // max-width: 376px;
    border-radius: 5px;
    //margin: 20px;
    height: 100%;
    display: flex;
    align-items: stretch;
    flex-direction: column;
    background-color: white !important;
    box-shadow: 0 2px 4px 0 rgba(198, 198, 198, 0.5) !important;
    &:hover {
        box-shadow: 0 2px 10px 0 rgba(198, 198, 198, 1) !important;
    }
    .md-card-content {
        position: relative;
    }
    &.no-cursor {
        cursor: default !important;
    }
}
.dot {
    height: 3px;
    width: 3px;
    background: #a4a4a4;
    border-radius: 50%;
    margin: 0 10px;
}
</style>
